import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

export type WeekDay = 'mon' | 'tue' | 'wed' | 'thu' | 'fri' | 'sat' | 'sun'

export interface DayChipToggleProps {
  day: WeekDay
  label: string
  selected: boolean
  onToggle: () => void
  disabled?: boolean
}

/**
 * Story 3.16.1 — toggle button styled como chip for weekday selection.
 *
 * Composto sobre `<Button>` atom (REUSE — IDS-compliant); apenas adiciona
 * estado `selected` visual + `aria-pressed` para a11y (toggle button
 * pattern WCAG 4.1.2). Acessibilidade: Tab navigation + Space/Enter para
 * toggle (herdado do native button).
 */
export function DayChipToggle({
  day,
  label,
  selected,
  onToggle,
  disabled = false,
}: DayChipToggleProps): React.ReactElement {
  return (
    <Button
      type="button"
      variant={selected ? 'default' : 'outline'}
      size="sm"
      aria-pressed={selected}
      aria-label={`${label} — ${selected ? 'selecionado' : 'não selecionado'}`}
      data-day={day}
      onClick={onToggle}
      disabled={disabled}
      className={cn(
        'min-w-[56px] transition-colors',
        selected ? 'bg-primary text-primary-foreground' : 'bg-muted/30 text-muted-foreground',
      )}
    >
      {label}
    </Button>
  )
}
